var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getComponent(_vm.message),{tag:"component",attrs:{"message":_vm.message,"referrers-map":_vm.referrersMap}})}
var staticRenderFns = []

export { render, staticRenderFns }